/* eslint-disable react/jsx-no-duplicate-props */
import CloseIcon from '@mui/icons-material/Close';
import { Fab, Radio } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { Select } from 'antd';
import _ from 'lodash';
import * as React from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import * as Yup from 'yup';

import DateField from '../../../../components/UI/DateField';
import { createSafalEventInvite, getNewBuddyList, updateSafalEventTodo } from '../../../../services/Service';
import { transformYupErrorsIntoArray } from '../../../../utils/fn';
import DynamicFormModal from '../DynamicForm/DynamicFormModal';
import DynamicFormViewModal from '../DynamicForm/DynamicFormViewModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  maxHeight: '95vh',
  overflow: 'auto',
  flexDirection: 'column',
  gap: '12px',
  p: 4,
  '@media (max-width: 640px)': {
    width: '95vw',
    height: '95vh',
    overflow: 'auto',
  },
};

const validationSchema = Yup.object().shape({
  // people: Yup.array().min(1, 'At least 1 email required').required('required'),
  form: Yup.string().required('required'),
});

const resetFieldValue = {
  onlyRSVP: false, // optional
  expiryDate: '', // optional ISO feature date
  people: [], // required assignee array
};

export default function AddModalInvite({ data, open, onClose, isDisplay, eventInfo }) {
  const { user } = useSelector((state) => state.login);
  // const dispatch = useDispatch();

  const [formModalControl, setFormModalControl] = React.useState({
    open: false,
    data: null,
    isDisplay: false,
  });
  const [viewModal, setViewModal] = React.useState({
    open: false,
    data: [],
  });

  const [fieldValue, setFieldValue] = React.useState({ ...resetFieldValue });
  const [fieldValueError, setFieldValueError] = React.useState([]);
  const [isDisableAll, setIsDisableAll] = React.useState(false);

  const [imagesFile, setImagesFile] = React.useState(null);
  const [dynamicFormData, setDynamicFormData] = React.useState(null);
  const [buddyList, setBuddyList] = React.useState([]);

  const onCloseThis = (refetchFlag, resData) => {
    setIsDisableAll(false);
    setFieldValue({ ...resetFieldValue });
    setFieldValueError([]);
    setImagesFile(null);
    setDynamicFormData(null);
    onClose(refetchFlag, resData);
  };

  const updateFieldValue = data
    ? {
        onlyRSVP: data?.onlyRSVP ?? false,
        expiryDate: data?.expiryDate ?? '',
        people: data?.people?.map((p) => p?.email) ?? [],
      }
    : resetFieldValue;

  const onFormModalClose = (refetchFlag, resData) => {
    resData && setDynamicFormData(resData);
    setFormModalControl({
      open: false,
      data: null,
      isDisplay: false,
    });
    // if (refetchFlag === true) refetch();
  };

  const handleClose = async (refetchFlag, directClose, resData) => {
    if (isDisplay) {
      onCloseThis(refetchFlag, resData);
      return;
    }
    if (directClose) {
      onCloseThis(refetchFlag, resData);
      return;
    }

    if (_.isEqual(updateFieldValue, fieldValue)) {
      onCloseThis(refetchFlag, resData);
      return;
    }
    const result = await Swal.fire({
      text: 'Are you sure you want to close this?',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      appendTo: 'body',
      customClass: {
        container: 'my-swal', // Add a custom class for styling
      },
      onBeforeOpen: () => {
        // Set a higher zIndex for the Swal modal
        document.querySelector('.my-swal').style.zIndex = 999999;
      },
    });

    if (result.isConfirmed) {
      onCloseThis(refetchFlag, resData);
    }
  };

  React.useEffect(() => {
    getNewBuddyList().then((res) => res.data?.data && setBuddyList(res.data.data));
  }, []);

  React.useEffect(() => {
    if (open === true && data !== null) {
      setFieldValue(updateFieldValue);
      setIsDisableAll(isDisplay);
    }
  }, [open, data, isDisplay]);

  const onSubmit = async () => {
    const assigneeMap = fieldValue?.people?.map((email) => {
      const findBuddy = buddyList?.find((u) => u?.metaUser?.email === email);
      if (findBuddy) {
        return {
          account: findBuddy?.metaUser?._id,
          buddy: findBuddy?._id,
          email: findBuddy?.metaUser?.email,
          // phoneNumber: '',
          fullName: `${findBuddy?.metaUser?.firstName} ${findBuddy?.metaUser?.lastName}`,
        };
      }
      return {
        email: email,
      };
    });

    setIsDisableAll(true);
    setFieldValueError([]);
    try {
      const payload = {
        ...fieldValue,
        people: assigneeMap,
        event: eventInfo._id,
      };
      if (dynamicFormData) payload.form = dynamicFormData?._id || '';

      await validationSchema.validate(payload, { abortEarly: false, strict: false });

      const res = await createSafalEventInvite(payload);
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose(true, true, res.data.data);
      }
    } catch (err) {
      setFieldValueError(transformYupErrorsIntoArray(err));
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const onUpdate = async () => {
    setIsDisableAll(true);
    setFieldValueError([]);
    try {
      const payload = {
        ...fieldValue,
      };
      await validationSchema.validate(payload, { abortEarly: false, strict: false });

      const res = await updateSafalEventTodo({ ...payload, _id: data._id });
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose(true, true);
      }
    } catch (err) {
      setFieldValueError(transformYupErrorsIntoArray(err));
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  return (
    <>
      <Modal sx={{ zIndex: 345 }} open={open} onClose={handleClose}>
        <Box sx={style}>
          <Fab
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
            onClick={handleClose}
            size="small"
            color="primary"
            aria-label="add"
          >
            <CloseIcon />
          </Fab>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h4" gutterBottom sx={{ fontSize: '24px', fontWeight: 700, color: '#3D71FF' }}>
              {data === null ? `Create Event Invite` : isDisplay ? `Event Invite` : `Update Invent`}
            </Typography>
          </div>
          <div className="sm-flex-direction-column" style={{ display: 'flex', gap: '16px', marginTop: '16px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', flex: '1 1 0%' }}>
              <span>Event : {eventInfo?.name}</span>
              {/* {dynamicFormData && <span>Attached Form : {dynamicFormData?.name}</span>} */}
              {/* onlyRSVP */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <span>Only SafalSubscriptions Users</span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Radio
                    disabled={isDisableAll}
                    checked={!fieldValue.onlyRSVP}
                    onChange={() =>
                      setFieldValue({
                        ...fieldValue,
                        onlyRSVP: false,
                      })
                    }
                    value="False"
                    name="onlyRSVP-radio-buttons"
                  />
                  <span>Yes</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Radio
                    disabled={isDisableAll}
                    checked={fieldValue.onlyRSVP}
                    onChange={() =>
                      setFieldValue({
                        ...fieldValue,
                        onlyRSVP: true,
                      })
                    }
                    value="True"
                    name="onlyRSVP-radio-buttons"
                  />
                  <span>No</span>
                </div>
              </div>
              {/* expiryDate */}
              <DateField
                disablePast
                disabled={isDisableAll}
                value={fieldValue.expiryDate}
                fullWidth
                variant="standard"
                label={<Typography sx={{ color: '#B6B6B6' }}>Expiry Date</Typography>}
                onChange={(e) => e?.isValid() && setFieldValue((prev) => ({ ...prev, expiryDate: e.toISOString() }))}
                error={fieldValueError?.find((e) => e.key === 'expiryDate')}
                helperText={fieldValueError?.find((e) => e.key === 'expiryDate')?.error}
              />
              <Select
                title="State"
                mode="tags"
                allowClear
                disabled={isDisableAll}
                style={{
                  flex: '1',
                }}
                variant="outlined"
                dropdownStyle={{
                  zIndex: 20000,
                }}
                value={fieldValue?.people}
                // defaultValue={fieldValue.state}
                placeholder="Select buddy or Enter Email ids"
                onChange={(values) => setFieldValue((prev) => ({ ...prev, people: values }))}
                options={
                  buddyList?.map((exs) => ({
                    label: `${exs?.metaUser?.firstName} ${exs?.metaUser?.lastName} (${exs?.metaUser.email})`,
                    value: exs?.metaUser?.email,
                  })) || []
                }
              />
              <span>
                Select Buddies or Enter Email address, If you leave this blank, then a public link will be generated,
                you can share this link via platform.
              </span>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              gap: '12px',
              marginTop: '22px',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              {dynamicFormData && (
                <Button
                  disabled={isDisableAll}
                  onClick={() => setDynamicFormData(null)}
                  sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                  variant="contained"
                >
                  Remove RSVP Form
                </Button>
              )}
              {(data?.formData || dynamicFormData) && (
                <Button
                  onClick={() => {
                    const element = data?.formData?.element || dynamicFormData?.element || [];
                    setViewModal({
                      data: element,
                      open: true,
                    });
                  }}
                  sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                  variant="contained"
                >
                  View RSVP Form
                </Button>
              )}
              {!isDisplay && !dynamicFormData && (
                <>
                  <Button
                    disabled={isDisableAll}
                    onClick={() =>
                      setFormModalControl({
                        open: true,
                        data: null,
                        isDisplay: false,
                      })
                    }
                    sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                    variant="contained"
                  >
                    Attach RSVP Form
                  </Button>
                  {fieldValueError?.find((e) => e.key === 'form') && (
                    <span>{fieldValueError?.find((e) => e.key === 'form')?.error}</span>
                  )}
                </>
              )}
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '22px', alignItems: 'center' }}>
              <Button
                disabled={isDisplay ? false : isDisableAll}
                sx={{
                  backgroundColor: '#ff4842',
                  ':hover': { backgroundColor: '#d40700' },
                  color: 'white',
                  borderRadius: '30px',
                  textTransform: 'capitalize',
                }}
                onClick={handleClose}
                variant="contained"
              >
                Cancel
              </Button>
              {!isDisplay && data === null && (
                <Button
                  disabled={isDisableAll}
                  onClick={onSubmit}
                  sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                  variant="contained"
                >
                  Create
                </Button>
              )}
              {!isDisplay && data !== null && (
                <Button
                  disabled={isDisableAll}
                  // onClick={onUpdate}
                  sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                  variant="contained"
                >
                  Save
                </Button>
              )}
            </div>
          </div>
        </Box>
      </Modal>
      <DynamicFormModal
        open={formModalControl.open}
        onClose={onFormModalClose}
        isDisplay={formModalControl.isDisplay}
        data={formModalControl.data}
        eventInfo={eventInfo}
      />
      <DynamicFormViewModal
        open={viewModal.open}
        data={viewModal.data}
        onClose={() => {
          setViewModal({
            data: [],
            open: false,
          });
        }}
      />
    </>
  );
}
